import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject, firstValueFrom, Observable} from "rxjs";
import { version as appVersion } from '@package';
import { isDevMode } from '@angular/core';
import { logger } from "@services/logger/logger.service";

interface IVersionResponse {
    version: string
}

export interface IVersion {
    actual: string;
    new: string
}

@Injectable({
    providedIn: 'root'
})
export class AppVersionService {
    private isVersionOld: BehaviorSubject<IVersion | null> = new BehaviorSubject<IVersion | null>(null)
    constructor(private http: HttpClient) {
    }

    public async checkAppVersion(): Promise<void> {
        if (isDevMode()) {
            return;
        }

        const url = `${window.location.origin}/version.json?date=${Date.now()}`;
        const request = this.http.get<IVersionResponse>(url, {responseType: 'json'});
        const { version } = await firstValueFrom<IVersionResponse>(request);

        logger.log('App version:', appVersion);
        logger.log('Json version:', version);

        if (appVersion !== version) {
            const versionData = {
                actual: appVersion,
                new: version
            }
            this.isVersionOld.next(versionData);
            return;
        }
        this.isVersionOld.next(null)
    }

    public getIsVersionOld(): Observable<IVersion | null> {
        return this.isVersionOld.asObservable()
    }

}
